var map = {
	"./enjojj/enjojj_brand_logo.png": "1f79",
	"./enjojj/enjojj_logo.png": "9029",
	"./images/dankoff_logo.png": "3215",
	"./images/hermelin_brand_logo.png": "5c43"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "08ce";